import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";
import { Grid } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import InputLabel from "@material-ui/core/InputLabel";

export const STGrid = styled(Grid)`
  && {
    ${theme.breakpoints.only("xs")} {
      justify-content: center;
    }
  }
`;

export const STProfileFieldsWrapper = styled.div`
  && {
    max-width: 500px;

    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
    }

    ${theme.breakpoints.up("sm")} {
      min-width: 360px;
    }
  }
`;

export const STImg = styled.img`
   {
    height: 20px;
    wight: 20px;
    margin-right: 5px;
  }
`;

export const STInputLabel = styled(InputLabel)`
   {
    width: 100%;
    display: block;
    margin-top: 8px;
    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    transform: scale(0.75);
  }
`;

export const STLink = styled(Link)`
  {
    color: #547F00 !important; 
    text-decoration:none !important
    width: 100%;
    display: flex !important;
    align-items: center;
  }
`;
